import React, { useEffect, useState } from 'react';
import ProjectListDumb from './ProjectListDumb';
import queryString from 'query-string';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useUser, useList, useProject } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import { Alert, ModalAlert, ErrorScreen } from 'components/common';
import withRequest from 'hoc/withRequest';
import { ROUTES } from 'consts';

const ProjectListSmart = (props) => {
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const { getContentList, content, error, isLoaded } = useList('projects');
  const hproyect = useProject();
  const history = useHistory();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [projectSelected, setProjectSelected] = useState(null);
  let { search } = queryString.parse(props.location.search);

  const handleListPage = () => {
    const query = {}
    if (search) {
      query.search = search;
    }
    getContentList({ query });
  };

  const handleCleanUp = () => {
    hproyect.cleanUpMessage();
  }

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;
    let routeToPush = `${ROUTES.PROJECT_LIST}`;
    if (data.search !== '') {
      routeToPush = `${routeToPush}?search=${data.search}`
    }
    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  };

  const handleCreate = () => {
    handleCleanUp();
    history.push(ROUTES.PROJECT_CREATE);
  };

  const handleEdit = (proyect) => {
    handleCleanUp();
    history.push(`${ROUTES.PROJECT_EDIT}/${proyect.project_id}`);
  };

  const handleDelete = () => {
    const { project_id } = projectSelected;
    hproyect.deleteProject({
      body: { project_id },
    });
    setOpenModal(false);
  };

  const handleModalDelete = (project) => {
    setProjectSelected(project);
    setOpenModal(true);
  };

  const handleSync = (project) => {
    hproyect.syncProject({
      body: { project_id: project.project_id }
    });
  };

  const alerts = [
    {
      severity: 'success',
      open: hproyect.success.post,
      message: 'projectList.components.alert.success',
    },
    {
      severity: 'success',
      open: hproyect.success.delete,
      message: 'projectList.components.alert.deleteSuccess',
    },
    {
      severity: 'info',
      open: hproyect.success.put,
      message: 'projectList.components.alert.putSuccess',
    },
    {
      severity: 'info',
      open: hproyect.success.sync,
      message: 'projectList.components.alert.syncSuccess', // Need to add this translation key or use a generic one
    },
    {
      severity: 'error',
      open: hproyect.error.put,
      message: 'projectList.components.alert.error',
    },
    {
      severity: 'error',
      open: hproyect.error.delete,
      message: 'projectList.components.alert.error',
    },
    {
      severity: 'error',
      open: hproyect.error.post,
      message: 'projectList.components.alert.error',
    },
    {
      severity: 'error',
      open: hproyect.error.sync,
      message: 'projectList.components.alert.error',
    },
  ];

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if (
      hproyect.success.get ||
      hproyect.success.post ||
      hproyect.success.put ||
      hproyect.success.delete ||
      hproyect.success.sync
    ) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    hproyect.success.get,
    hproyect.success.post,
    hproyect.success.put,
    hproyect.success.delete,
    hproyect.success.sync,
  ]);

  return (
    <>
      { error ? (
        <ErrorScreen />
      ) : (
        <ProjectListDumb
          handleSearch={handleSearch}
          searchValue={search}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          handleDelete={handleModalDelete}
          handleSync={handleSync}
          content={content}
          options={projects}
          isLoaded={isLoaded}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => hproyect.cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={handleDelete}
      />
    </>
  );



}

export default withRequest(withRouter(ProjectListSmart));
